import { render } from "./LRBg.vue?vue&type=template&id=18442cbc&scoped=true"
const script = {}

import "./LRBg.vue?vue&type=style&index=0&id=18442cbc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lp\\Desktop\\ConfChair\\用户端\\vue-conference\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18442cbc"]])

export default __exports__